import { Provider } from '@angular/core';
import { COUNTRY_ISO_NUMBER } from '@i18n';
import { addressFormBuilderFactory } from '../factories/address-form-builder/address-form-builder.factory';
import { addressProvinceFormOptionsFactory } from '../factories/address-province-form-options/address-province-form-options.factory';
import { AddressFormBuilder } from '../services/address-form-builder/address-form-builder.service';
import { ADDRESS_PROVINCE_FORM_OPTIONS } from '../tokens/address-province-form-options.token';
import { provideFormsAddressI18n } from './forms-address-i18n.provider';

export function provideFormsAddressDefaults(): Provider {
  return [
    provideFormsAddressI18n(),
    {
      provide: AddressFormBuilder,
      useFactory: addressFormBuilderFactory,
      deps: [COUNTRY_ISO_NUMBER],
    },
    {
      provide: ADDRESS_PROVINCE_FORM_OPTIONS,
      useFactory: addressProvinceFormOptionsFactory,
      deps: [COUNTRY_ISO_NUMBER],
    },
  ];
}
